import { Maybe } from '@/types-aggregatore';
import { capitalizeWordsInString } from './string';

export const makeFullAddress = (
  street?: Maybe<string>,
  cap?: Maybe<string>,
  city?: Maybe<string>,
  streetNumber?: Maybe<string>,
): Maybe<string> => (street && city ? capitalizeWordsInString(`${street} ${streetNumber || ''} - ${cap || ''} ${city}`) : null);

export const delay = (ms: number) => new Promise(res => setTimeout(res, ms));
